export enum Section2ValidationErrors {
    documentDetailMissing = 'documentDetailMissing',
    confirmDocumentsPhysicallyExamined = 'confirmDocumentsPhysicallyExamined',
    confirmAgreeToSign = 'confirmAgreeToSign',
    provideSignDate = 'provideSignDate',
    provideLastName = 'provideLastName',
    provideFirstName = 'provideFirstName',
    confirmESignAgreement = 'confirmESignAgreement',
    documentNumberDoesNotMatchSection1 = 'documentNumberDoesNotMatchSection1'
}



// WEBPACK FOOTER //
// ./src/models/onboarding-review/section2-validation-errors.ts